import { Text, useToast } from "@chakra-ui/react";
import { H2 } from "components/text/headings";
import { useEffect, useState } from "react";
import { useRerender } from "rerenderer";
import { useQuery, useQueryClient } from "react-query";
import { showErrorToast } from "utils";
import questionnaireService from "api/issb/questionnaire.service";
import { MultiSelect } from "../../../components";
import { Card } from "../../../components/Card";
import { useAuth } from "context";
import { issbKeys } from "hooks/query";
import { round_as_source_sync_questions } from "api/ai/ai.service";
/**
 * Select source rounds - and update the Round object and save it.
 * 
 * IF selectedRounds / setSelectedRounds are not provided, then the component will work on round.sourceRoundIds.
 * 
 * Note: likely to be redesigned
 * 
 * @param {*} param0 
 * @returns 
 */
export default function SourcesRoundsAsSourceSelector({ currentRoundId, selectedRounds, setSelectedRounds }) {
	const { getAccessTokenSilently } = useAuth();
	const queryClient = useQueryClient();
	const { data: roundsListData } = useQuery(issbKeys.questionnaireRound(),
		async () => {
			await getAccessTokenSilently();
			return questionnaireService.list({})
		}, {
		enabled: true
	});

	let roundOptions = [];
	if (roundsListData?.content) {
		roundOptions = roundsListData?.content?.filter((r) => r.id !== currentRoundId).map((r) => ({ label: r.name, value: r.id }));
	}

	const toast = useToast();

	const { data: questionnaireData } = useQuery(currentRoundId, async () => {
		await getAccessTokenSilently();
		return questionnaireService.get(currentRoundId);
	}, {
		enabled: !!currentRoundId
	});
	// Use questionnaireData?.sourceRoundIds directly?
	if ( ! setSelectedRounds || ! selectedRounds) {
		selectedRounds = questionnaireData?.sourceRoundIds || [];
	}

	const { rerender } = useRerender();

	useEffect(
		() => {
			if (questionnaireData && setSelectedRounds) {
				setSelectedRounds(questionnaireData?.sourceRoundIds || []);
			}
		}, [questionnaireData, setSelectedRounds])

	const handleOnChange = (value) => {		
		let roundIds = value.map((v) => v.value);
		console.warn("handleOnChange", roundIds);
		if (setSelectedRounds) {
			setSelectedRounds(roundIds);
		} else {
			console.log("handleOnChange: updating questionnaireData.sourceRoundIds", roundIds);
			questionnaireData["sourceRoundIds"] = roundIds;
			questionnaireService.update(currentRoundId, questionnaireData, {})
				.catch(err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message));
			// HACK reset the query cache to trigger an udpate in AI Review sources panel if its active
			queryClient.invalidateQueries(issbKeys.questionnaireRound(currentRoundId));
			// This is used in Sources. Proactively ask the AI server to sync (which will help avoid timeout if AI chat is then used)
			// The other branch is used in AIReviewSourcesPanel, and it will sync the sources as part of the AI review.
			for (const roundId of roundIds) {
				round_as_source_sync_questions(roundId);
			}
		}
		rerender();
	} // .handleOnChange

	return (
		<Card
			border="1px solid"
			borderColor="gray.400"
			width="50%"
			my={4}
		>
			<H2>Round (s)</H2>
			<Text mb={4} color="gray.500">This will reference any questions from the round(s) selected as a draft answer</Text>
			<MultiSelect
				isMulti={true}
				options={roundOptions}
				value={roundOptions.filter((o) => selectedRounds.includes(o.value))}
				onChange={(value) => handleOnChange(value)}
			/>
		</Card>
	);
};
